import { useToast } from '@monorepo/shared/contexts/ToastContext';
import { useCopySqlForSigmaDataModel } from '@monorepo/shared/hooks/analyticsSync/useCopySqlForSigmaDataModel';
import { useCallback } from 'react';

export const useHandleCopySql = (
  datasetOriginLabel: string,
  setIsFetchingSql: (isFetchingSql: boolean) => void,
) => {
  const { showUserFriendlyErrorToast, success: showSuccessToast } = useToast();

  const [copySqlForSigmaDataModel] = useCopySqlForSigmaDataModel({
    config: { throwOnError: true },
  });
  const handleCopySql = useCallback(
    async (datasetId: string, organizationId: string) => {
      setIsFetchingSql(true);
      try {
        await copySqlForSigmaDataModel({
          inputDatasetId: datasetId,
          organizationId,
        });
        showSuccessToast(
          `Successfully copied SQL to your clipboard. You can use it to create a Data Model in Sigma that will be populated with the data from this ${datasetOriginLabel}.`,
          { autoHideDuration: 15 * 1000 },
        );
      } catch (err) {
        showUserFriendlyErrorToast(
          err,
          `Unable to copy SQL for Sigma Data Model for this ${datasetOriginLabel}.`,
          { dontAutoHide: true },
        );
      } finally {
        setIsFetchingSql(false);
      }
    },
    [
      setIsFetchingSql,
      copySqlForSigmaDataModel,
      showSuccessToast,
      datasetOriginLabel,
      showUserFriendlyErrorToast,
    ],
  );
  return handleCopySql;
};
